import { useContext } from 'react';

import { useNotesContext } from '../../../../contexts/NotesContext';
import { MapContext } from '../../../../contexts/MapContext';
import { Note } from './Note';

const useOnNoteClick = () => {
  const { currentNoteId, setCurrentNoteId } = useNotesContext();
  const {
    mapState: { hasDirtyNote, setConfirmNoteModalOpen },
  } = useContext(MapContext);

  return (e) => {
    if (e.detail === 2) return; // Handle double click for renaming notes
    const targetId = e.currentTarget.id;

    const noteIdToSet = targetId === currentNoteId ? null : targetId;
    if (hasDirtyNote) {
      setConfirmNoteModalOpen(true);
    } else {
      setCurrentNoteId(noteIdToSet);
    }
  };
};

const NotesList = ({ notes }) => {
  const { currentNoteId } = useNotesContext();
  const onNoteClick = useOnNoteClick();

  return (
    <div className="mb-2">
      {notes.map((note) => (
        <Note
          key={note.id}
          title={note.title}
          id={note.id}
          onClick={onNoteClick}
          selected={note.id === currentNoteId}
        />
      ))}
    </div>
  );
};

export default NotesList;
